export default __webpack_public_path__ + "static/helphcase2-efe19c4520d014399831243737b2410e.png";